export default __webpack_public_path__ + "static/media/facebook.28db5771.svg";